/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TechPowerButtonIcon16Regular = forwardRef('TechPowerButtonIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M8.75 1a.75.75 0 0 0-1.5 0v6a.75.75 0 0 0 1.5 0V1Z" }),
        React.createElement("path", { d: "M4.798 3.528a.75.75 0 0 0-.873-1.22 7 7 0 1 0 8.158.006.75.75 0 0 0-.875 1.218 5.5 5.5 0 1 1-6.41-.004Z" })));
});
